import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import { formatDateTimeFromISO } from 'src/common/helper';

const rowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  '&.MuiTableRow-root .MuiTableCell-root.MuiTableCell-body': {
    py: '16px',
    borderBottom: '1px solid #F3F3F3',
  },
  cursor: 'pointer'
}

type DetailHistoryListType = {
  dataAnswers: any;
  handleRowClick: (log: any) => void;
};
const DetailHistoryList: React.FC<DetailHistoryListType> = (props) => {
  const [rowActive, setRowActive] = useState(0)

  const handleRowClick = (log: any, index: number) => {
    setRowActive(index)
    props.handleRowClick(log)
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        width: '100%',
        height: '100%',
      }}
    >
      <Table
        sx={{
          // minWidth: 700,
          '& .MuiTableCell-root.MuiTableCell-head': {
            borderBottom: '1px solid #F3F3F3',
            fontWeight: 700,
            p: '6px 16px',
            fontSize: '14px',
          },
          '& .MuiTableCell-root.MuiTableCell-body': {
            color: 'primary.dark',
            fontSize: '14px',
            py: '6px',
          },
        }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            <TableCell width={'170px'}>日時</TableCell>
            <TableCell>更新者</TableCell>
            <TableCell>区分</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.dataAnswers &&
            props.dataAnswers.map((log: any, index: number) => (
              <TableRow
                key={index}
                sx={{...rowStyle, '&.MuiTableRow-root': {backgroundColor: rowActive === index ? '#eee' : ''}}}
                onClick={() => handleRowClick(log, index)}
              >
                <TableCell>{formatDateTimeFromISO(log.submitted_at)}</TableCell>
                <TableCell>{log.is_updated_by_staff ? log.updated_by : '-'}</TableCell>
                <TableCell>{log.is_updated_by_staff ? 'スタッフ' : 'ユーザー'}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailHistoryList;
